import http from 'hub-http/clients/apiClient';
export const generateLeadWithAction = ({
  offeringId,
  action
}) => {
  return http.put(`ecosystem/v1/customers/${offeringId}/lead/${action}`, {});
};